import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CvStudioConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CvStudioService } from './api/cvStudio.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CvStudioApiModule {
    public static forRoot(configurationFactory: () => CvStudioConfiguration): ModuleWithProviders<CvStudioApiModule> {
        return {
            ngModule: CvStudioApiModule,
            providers: [ { provide: CvStudioConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CvStudioApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CvStudioApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
